import React, { Component } from 'react';
import lodash from 'lodash';

import styles from './Table.scss';

export default class Table extends Component {

    getHeaders() {
        const { columns } = this.props;
        return (
            <div className={styles.header} data-cy="Table-header">
                {columns.map((column, i) => <span key={i} className={styles.title} style={{ ...column.styles }} data-cy={'Table-' + i}> {column.header} </span>)}
            </div>
        );
    }

    getList() {
        const { columns, data, rowClickHandler } = this.props;

        const list = data.map((item, i) => {
            const rowStyles = rowClickHandler ? `${styles.row} ${styles.row__active}` : styles.row;
            
            return (
                <li 
                    className={rowStyles} 
                    onClick={rowClickHandler && (() => rowClickHandler(item))}
                    key={i}
                    data-cy={i + '-Table'}>
                    {columns.map((column, i) => this.getCellComponent(item, column, i))}
                </li>
            );
        });

        return list;
    }

    getCellComponent(item, column, index) {
        const hasCellComponent = !lodash.isNil(column.component);
        const value = lodash.get(item, column.accessor);

        return (
            <span key={index} style={{...column.styles}} className={styles.row__item} data-cy={index + '-Table-span'}>
                {hasCellComponent ? column.component(item) : value}
            </span>
        );
    }

    render() {
        const list = this.getList();

        return list.length === 0 ? null : (
            <section className={styles.Table} data-cy="Table-section">
                {this.getHeaders()}
                <ul className={styles.body} data-cy="Table-ul">
                    {list}
                </ul>
            </section>
        );
    }
}
